export const funnelTrackingConstants = Object.freeze({
  allCoursesContext: 'all-courses',
  featuredContext: 'featured',
  featuredPageContext: 'feature',
  myCoursesContext: 'my-courses',
  learningContext: 'learning',
  collectionContext: 'collection',
  wishlistContext: 'wishlist',
  searchPage: 'search',
  // for use in subcontext2
  becauseYouEnrolled: 'enroll-recommendation',
  becauseYouSearched: 'search-recommendation',
  becauseYouViewed: 'view-recommendation',
  bestsellers: 'best-seller',
  studentsAreViewing: 'students-are-viewing',
  newAndNoteworthy: 'new-and-noteworthy',
  learningPack: 'learning-pack',
  yourWishlist: 'wishlist',
  frequentlyBought: 'frequentitemsrecommendation',
  tagBasedUnit: 'tag-du',
  topicPage: 'topic',
  topic: 'all-courses',
  onboardingContext: 'onboarding-success',
  channelContextMap: {
    cart: 'cart',
    category: 'cat_ch',
    collection: 'coll_ch',
    dynamic_tag_collection: 'cl',
    keyword: 'kw_ch',
    featured: 'ft_ch',
    logged_in_homepage: 'ft_ch',
    logged_out_homepage: 'home_ch',
    personalized_home: 'home_ch',
    home: 'home_ch',
    subcategory: 'scat_ch',
    topic: 'cl',
    landingPageCourse: 'landing-page',
    landingPageFreeCourse: 'clp-free',
    occupation_landing_page: 'occupation_landing_page',
    subs_landing_page: 'subs_landing_page',
    org_logged_in_homepage_fixed_units: 'org_logged_in_homepage_fixed_units',
    subs_category: 'subs_category',
    org_category: 'org_category',
    subs_subcategory: 'subs_subcategory',
    org_subcategory: 'org_subcategory',
    subs_topic: 'subs_topic',
    org_topic: 'org_topic',
    logout_page: 'logout_page',
    disabled_course_label: 'disabled_course_label',
    disabled_course_category: 'disabled_course_category',
    subs_logged_in_homepage: 'subs_logged_in_homepage',
    vernacular_lohp: 'vernacular_lohp'
  }
});
//# sourceMappingURL=constants.js.map